import AsyncDataTable from "@/components/core/async-data-table/async-data-table";
import {
  DatableColumnType,
  FilterType,
  propertyType,
} from "@/components/core/async-data-table/type";
import { endpoints } from "@/api/endpoints/endpoints";
import FilterHeader from "@/components/core/async-data-table/filter-header";
import ActionPopover from "@/components/action/action-popover";
import { Plus } from "lucide-react";
import { useLocation } from "wouter";
import { useDeleteDeliveryFee } from "@/services/delivery-fee-service";
import { useToast } from "@/hooks/use-toast";
import { useState } from "react";

const DeliveryFeeAsyncTable = () => {
  const [, setLocation] = useLocation();
  const deleteDeliveryFee = useDeleteDeliveryFee();
  const [refreshPage, setRefreshPage] = useState(false);
  const { toast } = useToast();

  const handleDelete = async (deliveryFeeId: string) => {
    try {
      await deleteDeliveryFee.execute(deliveryFeeId);
      toast({
        title: "Success",
        description: "Delivery fee deleted successfully",
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to delete delivery fee",
        variant: "destructive",
      });
    }

    setRefreshPage(!refreshPage);
  };

  const cols: DatableColumnType[] = [
    {
      name: "name",
      id: "name",
      label: "Name",
      searchable: true,
      orderable: true,
      datatype: "string",
    },
    {
      name: "deliveryType",
      id: "deliveryType",
      label: "Delivery Type",
      searchable: true,
      orderable: true,
      datatype: "string",
    },
    {
      name: "price",
      id: "price",
      label: "Price",
      searchable: true,
      orderable: true,
      datatype: "custom",
      Render: ({ row }: { row: any }) => {
        if (!row.price) return <span className="text-sm text-gray-400">-</span>;
        return (
          <span className="text-sm text-gray-700 font-medium">
            ${parseFloat(row.price).toFixed(2)}
          </span>
        );
      },
    },
    {
      name: "description",
      id: "description",
      label: "Description",
      searchable: true,
      orderable: false,
      datatype: "string",
    },
    {
      name: "action",
      id: "action",
      label: "Action",
      Render: ({ row }: { row: any }) => (
        <ActionPopover
          onEdit={() => {
            setLocation(`/delivery-fees/${row.id}/edit`);
          }}
          onDelete={() => {
            handleDelete(row.id);
          }}
        />
      ),
    },
  ];

  const defaultFilterProp: propertyType[] = [
    { propName: "name", value: "", type: FilterType.STRING },
    { propName: "deliveryType", value: "", type: FilterType.STRING },
    { propName: "description", value: "", type: FilterType.STRING },
  ];

  return (
    <AsyncDataTable
      dataUrl={endpoints.deliveryFee.list}
      columns={cols}
      autoIndex
      FilterComponent={FilterHeader}
      refreshPage={refreshPage}
      defaultFilterProp={defaultFilterProp}
      showPageHeader={false}
      pageTitle="Delivery Fees"
      pageSubtitle="Manage your delivery fees"
      headerAction={() => {}}
      headerActionText="Create Delivery Fee"
      headerActionIcon={<Plus size={18} />}
    />
  );
};

export default DeliveryFeeAsyncTable;
